import { createContext, useContext } from "react";
import type { IconName } from "@components/v3/primitives";

/** What a stepped flow tells OnboardingLayout about where the investor is. */
export interface OnboardingStepChrome {
  /** A short line under the actions, e.g. how long the section takes. */
  reassurance?: StepReassuranceCopy;
}

export interface StepReassuranceCopy {
  text: string;
  icon: IconName;
}

const StepChromeContext = createContext<OnboardingStepChrome | null>(null);

/** Opts every OnboardingLayout below it into the dark, stepped presentation. */
export const OnboardingStepChromeProvider = StepChromeContext.Provider;

/** Null outside a stepped flow, so the layout keeps its classic look. */
export const useOnboardingStepChrome = (): OnboardingStepChrome | null =>
  useContext(StepChromeContext);
